import React from 'react';
import { Box } from '@chakra-ui/react';
import { Outlet } from 'react-router-dom';
import { Navbar, Footer } from './features/navigation';

function App() {
  return (
    <Box minH="100vh" display="flex" flexDirection="column">
      <Navbar />
      <Outlet />
      <Footer />
    </Box>
  );
}

export default App;